<template lang="pug">
    lairdnd-profile-edit(
        :settings="settings"
    )

</template>

<script>
export default {
    name: 'settings-profile-page',

    data() { return {
        settings: {
            form: {
                fields: {
                    phone: {
                        validations: false,
                    },
                    phone_confirmation: {
                        validations: false,
                    },
                    email_confirmation: {
                        validations: false,
                    },
                    birth_date: {
                        validations: false,
                    },
                },
            },
        },
    }},
}
</script>
